import React from 'react';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
export function DocsPage() {
  return <div className="min-h-screen bg-[#FAF9F7]" data-id="element-248">
      <Navigation data-id="element-249" />

      {/* Main Content */}
      <main className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12 py-24 sm:py-32" data-id="element-250">
        <article className="prose prose-lg max-w-none" data-id="element-251">
          <h1 className="text-4xl sm:text-5xl font-semibold text-gray-900 mb-12" style={{
          fontSize: '32px'
        }} data-id="element-252">
            How people discover brand is changing
          </h1>

          <div className="space-y-6 mb-12" data-id="element-253">
            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-254">
              People now ask questions instead of searching keywords. They turn
              to AI assistants for recommendations, comparisons, and answers,
              expecting conversational responses rather than lists of links.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-255">
              If a brand does not appear in AI answers, it often does not enter
              consideration. The moment of discovery has shifted, and visibility
              in these new spaces determines who gets found.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed" data-id="element-256">
              This course introduces "AI Search Visibility" as the practice of
              shaping how AI systems understand and represent brands. It's about
              ensuring your brand is present, accurate, and compelling when
              people ask the questions that matter.
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-x-4 gap-y-2" data-id="element-257">
            <a href="https://course.andoe.work/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-gray-900 hover:bg-gray-500 rounded-full transition-all duration-200" data-id="element-258">
              Access the course
            </a>
          </div>
        </article>
      </main>

      <Footer data-id="element-259" />
    </div>;
}